"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
const tooltip_1 = __importDefault(require("./tooltip"));
require("../../styles/components/label-with-tooltip.less");
const LabelWithTooltip = ({ label }) => {
    const labelRef = (0, react_1.useRef)();
    const [shouldShowTooltip, setShouldShowTooltip] = (0, react_1.useState)(false);
    const checkIfTooltipIsNeeded = (0, react_1.useCallback)(() => {
        const isOverflowing = labelRef?.current?.offsetWidth < labelRef?.current?.scrollWidth;
        if (!shouldShowTooltip && isOverflowing) {
            setShouldShowTooltip(true);
        }
    }, [shouldShowTooltip, labelRef]);
    return (react_1.default.createElement(tooltip_1.default, { title: label, removeTooltip: !shouldShowTooltip },
        react_1.default.createElement("span", { onMouseEnter: checkIfTooltipIsNeeded, ref: labelRef, className: "label-with-tooltip-text" }, label)));
};
LabelWithTooltip.propTypes = {
    label: prop_types_1.default.string.isRequired,
};
exports.default = LabelWithTooltip;
//# sourceMappingURL=label-with-tooltip.js.map